module.exports = __webpack_public_path__ + "img/home-decor-4.019478d2.jpg";